// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grow-aov__products-loading{align-items:center;background:hsla(0,0%,100%,.7);display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%;z-index:7}.Polaris-Modal-Section{min-height:180px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
